import { CommonService } from './../../service/common.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService } from 'src/app/service/messageService';
import { WebService } from 'src/app/service/web.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ForgetPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public commonService: CommonService,
    private webService : WebService,
    private msgService: MessageService,
  ) { }

  ngOnInit(): void {
    if(this.data) {
      this.isChangePwd = this.data.isChangePwd;
    }

    let userName :any; 
      userName = localStorage.getItem("requestedUserId");
      if(userName != null && userName != undefined && userName != ""){
       this.requestedUserId = userName;
      }
  }

  isChangePwd: boolean = false;
  email: any;
  dob: any;
  newPwd: any;
  cnfPwd: any;

  requestedUserId : any;

  emailReq: boolean = false;
  dobReq: boolean = false;
  newPwdReq: boolean = false;
  cnfPwdReq: boolean = false;

  validateFgtPwd() {
    if(!this.commonService.validateText(this.email)) {
      this.emailReq = true;
    }
    if(this.dob == undefined || this.dob == null) {
      this.dobReq = true;
    }
  }

  handleEmil(event: any) {
    if(this.commonService.validateText(this.email)) {
      this.emailReq = false;
      return;
    }
    this.emailReq = true;
  }

  handleDob(event: any) {
    if(this.dob) {
      this.dobReq = false;
      return;
    }
    this.dobReq = true;
  }

  continue(event: any, data: any) {
    this.validateFgtPwd();
    if(this.emailReq || this.dobReq) {
      return;
    }

    let adduserVo  :any = {};
    adduserVo.email =  this.email;
    adduserVo.birthDate =  this.dob;


    this.webService.conFirmUser(adduserVo).subscribe((data:any)=>{

      let responce : any = data;
    if(responce != undefined && responce != {} && responce.id != undefined){
      this.requestedUserId = responce.id;
      let outPut  :any = {};

      localStorage.setItem("requestedUserId",this.requestedUserId);
        this.dialogRef.close(true);
    } else {
      localStorage.removeItem("requestedUserId");
      this.msgService.error("Invalid User Details");
    } 
  })
    // BuildObj & call
   
  }

  closePop(event: any, data: any) {
    this.dialogRef.close(false);
  }

  validateNewPwd() {
    if(!this.commonService.validateText(this.newPwd)) {
      this.newPwdReq = true;
    }
    if(!this.commonService.validateText(this.cnfPwd)) {
      this.cnfPwdReq = true;
    }
  }

  handleNewPwd(event: any) {
    if(this.commonService.validateText(this.newPwd)) {
      this.newPwdReq = false;
      return;
    }
    this.newPwdReq = true;
  }

  handleCnfPwd(event: any) {
    if(this.commonService.validateText(this.cnfPwd)) {
      this.cnfPwdReq = false;
      return;
    }
    this.cnfPwdReq = true;
  }

  changePwd(event: any, data: any) {
    this.validateNewPwd();
    if(this.newPwdReq || this.cnfPwdReq) {
      return;
    }
    if(this.newPwd != this.cnfPwd) {
      this.msgService.error("New Password and Confirm Password should be same")
      return;
    }

    if(this.requestedUserId == undefined || this.requestedUserId == "") {
      this.msgService.error("Invalid User details")
      return;
    }

    let adduserVo  :any = {};
    adduserVo.id =  this.requestedUserId;
    adduserVo.password =  this.newPwd;


    this.webService.changeUserPassword(adduserVo).subscribe((data:any)=>{

      let responce : any = data;
          if(responce.Item != undefined && responce.Item){

               localStorage.setItem("isAuthenticated","true");
               localStorage.setItem("userId",responce.Item.id);
               localStorage.setItem("userName",responce.Item.firstName + " "+ responce.Item.lastName);
               localStorage.setItem("userType",responce.Item.userType);
               
              this.dialogRef.close(true);
          } else {
      this.msgService.error("Error While Updating Password...");
    } 
  })
    // BuildObj & call
  }

}

export interface DialogData {
  isChangePwd: boolean;
  requestedUserId : any;
}
